import { render, staticRenderFns } from "./TrapezSOL.vue?vue&type=template&id=65f9e0fc&"
import script from "./TrapezSOL.vue?vue&type=script&lang=js&"
export * from "./TrapezSOL.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports